import { Navigate } from "react-router-dom";
import { useSelector, selectUser } from "../../features/userSlice";
import Loading from "../Loading/Loading";

function ProtectedRoute({ adminRoute, loginRoute, component }) {
	const { user, loading } = useSelector(selectUser);

	if (loading === false) {
		if (user === null && loginRoute === false) {
			if (adminRoute === true) {
				console.log("object");
				return <Navigate to="/admin" />;
			}
			return <Navigate to="/" />;
		}

		if (user !== null && adminRoute === true && user.role !== "admin") {
			return (
				<div className="h-full w-full flex items-center justify-center">
					<h1 className="text-2xl">
						403
						<br /> Forbidden
						<br /> <small>You don't have privileges to access this page.</small>
					</h1>
				</div>
			);
		}

		if (user !== null && loginRoute === true) {
			if (adminRoute === true) {
				return <Navigate to="/admin/landing" />;
			}
			return <Navigate to="/landing" />;
		}

		return component;
	} else {
		return <Loading />;
	}
}

export default ProtectedRoute;
